import React, { Component } from 'react';
import axios from 'axios';
import Breadcrumb from  '../../../components/Layout/Breadcrumb';
import ModalComponent from  '../../../components/ModalComponent';
import {FaProductHunt} from "react-icons/fa";
import {Card, CardBody, Table} from 'reactstrap';
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';
import { Spinner, Tab, Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ListGroupProductComponent from '../../../components/Admin/products/ListGroupProductComponent';

class ListProductPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loadPage: true,
            isLoading: true,
            listGroupProduct: [],
            listGroupUser: [],
            perPage: 0,
            totalPage: 0,
            currentPage: 0,
            error: false,
            messageError: '',
            isNotification: '',
            textNotification: '',
            isModal: false,
            titleModal: '',
            modalBody: '',
            groupUserId: 0,
            action: '',
            isBtnConfirm: true,
            contentModal: '',
            btnConfirmDisabled: false,
            isSpinner: false,
            actionKey: 0,
            name: '',
            titleGroup: '',
            type_product: '',
            group_user_id: 0,
            stt: 10,
            hidden: false,
            alert: {
                error: false,
                message: ''
            },
            groupProductId: 0,
            tabGroupUserId: 0,
            typeProduct: '',
            isLoadDingTab: false,
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.listGroupProduct();

        this.setState({
            isNotification: this.props.isNotification,
            textNotification: this.props.textNotification,
        })
        if ( this.props.isNotification ) {
            this.props.notification({
                isNotification: false,
                textNotification: ''
            });
        }
        // console.log(this.props.vps_gpu);
    }

    listGroupProduct = () => {
        this.setState({
            isLoading: true,
        });
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };

        let request = '?groupUserId=' + this.state.tabGroupUserId + '&typeProduct=' + this.state.typeProduct;

        axios.get( process.env.REACT_APP_API_URL + '/api/admin/product/getGroupProduct' + request,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                this.setState({
                    isLoading: false,
                    loadPage: false,
                });
                if ( ref.data.error === 0 ) {
                    this.setState({
                        listGroupProduct: ref.data.content,
                        listGroupUser: ref.data.listGroupUser,
                    })
                } else {
                    if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    error: true,
                    messageError: 'Lấy dữ liệu sản phẩm thất bại',
                    isLoading: false,
                    loadPage: false,
                })
            })
    }

    screentGroupProduct = () => {
        if ( this.state.isLoading ) {
            return (
                <div className="text-center">
                    <Spinner animation="grow" variant="primary" />
                    <Spinner animation="grow" variant="secondary" />
                    <Spinner animation="grow" variant="success" />
                    <Spinner animation="grow" variant="danger" />
                    <Spinner animation="grow" variant="warning" />
                    <Spinner animation="grow" variant="info" />
                </div>
            );
        }
        else {
            return (
                <Tab.Container defaultActiveKey="general">
                    <div className="row">
                        <div className="mb-3 col-md-8 pr-0">
                            <Nav variant="pills" className=" nav-product">
                                <Nav.Item>
                                    <Nav.Link disabled={true}><strong className="font-dai-ly">Đại lý</strong></Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="general" className="nav-pills" onClick={ () => this.changeGroupUser(0) }>Cơ bản</Nav.Link>
                                </Nav.Item>

                                {
                                    this.loadTabGroupUser()
                                }

                                <Nav.Item>
                                    <Nav.Link eventKey="all" className="nav-pills" onClick={ () => this.changeGroupUser(-1) }>Tất cả</Nav.Link>
                                </Nav.Item>
                            </Nav>
                        </div>
                        <div className="mb-3 col-md-4 pl-0 bg-lycan">
                            <div className="float-right form-group pt-2">
                                <select className="form-control" defaultValue={ this.state.typeProduct } onChange={this.changeTypeProduct}>
                                    <option value="" disabled={true}>Chọn loại sản phẩm</option>
                                    <option value="">Tất cả</option>
                                    {
                                        this.props.vps ? (
                                            <>
                                                <option value="vps">VPS</option>
                                                <option value="addon_vps">Addon VPS</option>
                                            </>
                                        ) : (
                                            <></>
                                        )
                                    }
                                    {
                                        this.props.vps_gpu ? (
                                            <>
                                                <option value="vps_gpu">VPS GPU</option>
                                                {
                                                    !this.props.vps ? (
                                                        <option value="vps_gpu">VPS GPU</option>
                                                    ) : (
                                                        <></>
                                                    )
                                                }
                                            </>
                                        ) : (
                                            <></>
                                        )
                                    }
                                    {
                                        this.props.nat_vps ? (
                                            <>
                                                <option value="nat_vps">NAT VPS</option>
                                                {
                                                    !this.props.vps ? (
                                                        <option value="addon_vps">Addon VPS</option>
                                                    ) : (
                                                        <></>
                                                    )
                                                }
                                            </>
                                        ) : (
                                            <></>
                                        )
                                    }
                                    {
                                        this.props.vps_us ? (
                                            <>
                                                <option value="vps_us">VPS US</option>
                                                <option value="vps_uk">VPS UK</option>
                                                <option value="vps_canada">VPS Canada</option>
                                                <option value="vps_singapore">VPS Singapore</option>
                                                <option value="vps_japan">VPS Japan</option>
                                            </>
                                        ) : (
                                            <></>
                                        )
                                    }
                                    {
                                        this.props.proxy ? (
                                            <>
                                                <option value="proxy">Proxy</option>
                                            </>
                                        ) : (
                                            <></>
                                        )
                                    }
                                    {
                                        this.props.cloudServer ? (
                                            <>
                                                <option value="cloud_server">Cloud Server</option>
                                                <option value="addon_cloud_server">Addon Cloud Server</option>
                                            </>
                                        ) : (
                                            <></>
                                        )
                                    }
                                    {
                                        this.props.hosting ? (
                                            <>
                                                <option value="hosting_cpanel">Hosting Cpanel</option>
                                            </>
                                        ) : (
                                            <></>
                                        )
                                    }
                                </select>
                            </div>
                        </div>
                    </div>
                    <Tab.Content>
                        <Tab.Pane eventKey="general">
                            {
                                this.loadTabContent()
                            }
                        </Tab.Pane>

                        { this.loadTabContentGroupUser() }

                        <Tab.Pane eventKey="all">
                            {
                                this.loadTabContent()
                            }
                        </Tab.Pane>
                    </Tab.Content>
                </Tab.Container>
            )
        }
    }

    loadTabGroupUser = () => {
        if ( this.state.listGroupUser.length ) {
            return (
                this.state.listGroupUser.map( (groupUser, key) => (
                    <Nav.Item key={key} onClick={ () => this.changeGroupUser(groupUser.id) }>
                        <Nav.Link eventKey={ 'groupUser' + groupUser.id } className="nav-pills">{ groupUser.name }</Nav.Link>
                    </Nav.Item>
                ))
            )
        }
    }

    loadTabContentGroupUser = () => {
        if ( this.state.listGroupUser.length ) {
            return (
                this.state.listGroupUser.map( (groupUser, key) => (
                    <Tab.Pane eventKey={ 'groupUser' + groupUser.id } key={key}>
                        {
                            this.loadTabContent()
                        }
                    </Tab.Pane>
                ))
            )
        }
    }

    loadTabContent = () => {
        if ( this.state.isLoadDingTab ) {
            return (
                <div className="text-center">
                    <Spinner animation="grow" variant="primary" />
                    <Spinner animation="grow" variant="secondary" />
                    <Spinner animation="grow" variant="success" />
                    <Spinner animation="grow" variant="danger" />
                    <Spinner animation="grow" variant="warning" />
                    <Spinner animation="grow" variant="info" />
                </div>
            );
        }
        else {
            if ( this.state.listGroupProduct.length )  {
                return (
                    <Table className="table-sm table-bordered table-hover rounded table-list">
                        <thead className="primary">
                            <tr>
                                <th width={"3%"}></th>
                                <th width={"20%"}>Tên sản phẩm</th>
                                <th width={"10%"}>Loại</th>
                                <th width={"15%"}>Thông tin</th>
                                <th width={"20%"}>Giá</th>
                                <th width={"10%"}>Trạng thái</th>
                                <th width={"10%"}>Mô tả</th>
                                <th width={"12%"}>Hành động</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.state.listGroupProduct.map( (groupProduct, key) => {
                                    return (
                                        <ListGroupProductComponent
                                            key={key}
                                            keyAction={key}
                                            groupProduct={groupProduct}
                                            showModal = { (keyAction, action) => this.showModal(keyAction, action) }
                                            showProduct = { (keyAction) => this.showProduct(keyAction) }
                                        />
                                    )
                                })
                            }
                        </tbody>
                    </Table>
                )
            }
            else {
                return (
                    <div className="text-center text-danger">
                        Không có sản phẩm trong dữ liệu
                    </div>
                )
            }
        }
    }

    showProduct = (keyAction) => {
        let listGroupProduct = this.state.listGroupProduct;
        listGroupProduct[keyAction].isClose = !listGroupProduct[keyAction].isClose;

        this.setState({
            listGroupProduct: listGroupProduct,
        })
    }

    changeGroupUser = (groupUserId) => {

        this.setState({
            isLoadDingTab: true,
            tabGroupUserId: groupUserId,
        });
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };

        let request = '?groupUserId=' + groupUserId + '&typeProduct=' + this.state.typeProduct;

        axios.get( process.env.REACT_APP_API_URL + '/api/admin/product/getGroupProduct' + request,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                this.setState({
                    isLoadDingTab: false,
                });
                if ( ref.data.error === 0 ) {
                    this.setState({
                        listGroupProduct: ref.data.content,
                        listGroupUser: ref.data.listGroupUser,
                    })
                } else {
                    if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    error: true,
                    messageError: 'Lấy dữ liệu sản phẩm thất bại',
                    isLoadDingTab: false,
                })
            })
    }

    changeTypeProduct = async (event) => {

        let typeProduct = event.target.type === 'checkbox' ? event.target.checked : event.target.value;

        await this.setState({
            isLoadDingTab: true,
            typeProduct: typeProduct
        });
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };

        let request = '?groupUserId=' + this.state.tabGroupUserId + '&typeProduct=' + typeProduct;

        await axios.get( process.env.REACT_APP_API_URL + '/api/admin/product/getGroupProduct' + request,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                this.setState({
                    isLoadDingTab: false,
                });
                if ( ref.data.error === 0 ) {
                    this.setState({
                        listGroupProduct: ref.data.content,
                        listGroupUser: ref.data.listGroupUser,
                    })
                } else {
                    if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    error: true,
                    messageError: 'Lấy dữ liệu sản phẩm thất bại',
                    isLoadDingTab: false,
                })
            })

    }

    showModal = (key, action) => {
        let titleModal;
        let modalBody;
        if ( action === 'createGroup' ) {
            titleModal = 'Tạo nhóm sản phẩm';
            modalBody = this.modalBody(key, action);
        }
        else if ( action === 'editGroup' ) {
            titleModal = 'Chỉnh sửa nhóm sản phẩm';
            modalBody = this.modalBody(key, action);
        }
        else if ( action === 'deleteGroup' ) {
            titleModal = 'Xóa nhóm sản phẩm';
            modalBody = this.modalBody(key, action);
        }
        else if ( action === 'deleteProduct' ) {
            titleModal = 'Xóa sản phẩm';
            modalBody = this.modalBody(key, action);
        }
        else if ( action === 'active' ) {
            titleModal = 'Hiện nhóm sản phẩm';
            modalBody = this.modalBody(key, action);
        }
        else if ( action === 'hidden' ) {
            titleModal = 'Ẩn nhóm sản phẩm';
            modalBody = this.modalBody(key, action);
        }
        this.setState({
            action: action,
            isModal: true,
            btnConfirmDisabled: false,
            contentModal: {
                modalBody: modalBody,
                title: titleModal
            },
            isBtnConfirm: true,
            isSpinner: false,
            actionKey: key
        })
    }

    hiddenModal = () => {
        this.setState({
            action: '',
            isModal: false,
        })
    }

    modalBody = (key, action) => {
        // console.log(this.props.proxy)
        if ( action === 'createGroup' ) {
            return (
                <>
                    <div className="form-group">
                        <label htmlFor="name">Tên nhóm sản phẩm</label>
                        <input type="text" name="name" className="form-control" id="name" placeholder="Tên nhóm sản phẩm" onChange={this.changeInput} />
                    </div>
                    <div className="form-group">
                        <label htmlFor="title">Tiêu đề hiển thị</label>
                        <input type="text" name="titleGroup" className="form-control" id="title" placeholder="Tiêu đề hiển thị" onChange={this.changeInput} />
                    </div>
                    <div className="form-group">
                        <label htmlFor="type_product">Loại</label>
                        <select className="form-control" name="type_product" id="type_product" onChange={this.changeInput} defaultValue={""}>
                            <option value="" disabled>Chọn loại sản phẩm</option>
                            {
                                this.props.vps ? (
                                    <>
                                        <option value="vps">VPS VN</option>
                                        <option value="addon_vps">Addon VPS</option>
                                    </>
                                ) : (
                                    <></>
                                )
                            }
                            {
                                this.props.vps_gpu ? (
                                    <>
                                        <option value="vps_gpu">VPS GPU</option>
                                    </>
                                ) : (
                                    <></>
                                )
                            }
                            {
                                this.props.nat_vps ? (
                                    <>
                                        <option value="nat_vps">NAT VPS</option>
                                        {
                                            !this.props.vps ? (
                                                <option value="addon_vps">Addon VPS</option>
                                            ) : (
                                                <></>
                                            )
                                        }
                                    </>
                                ) : (
                                    <></>
                                )
                            }
                            {
                                this.props.vps_us ? (
                                    <>
                                        <option value="vps_us">VPS US</option>
                                        <option value="vps_uk">VPS UK</option>
                                        <option value="vps_canada">VPS Canada</option>
                                        <option value="vps_singapore">VPS Singapore</option>
                                        <option value="vps_japan">VPS Japan</option>
                                    </>
                                ) : (
                                    <></>
                                )
                            }
                            {
                                this.props.proxy ? (
                                    <>
                                        <option value="proxy">Proxy</option>
                                    </>
                                ) : (
                                    <></>
                                )
                            }
                            {
                                this.props.cloudServer ? (
                                    <>
                                        <option value="cloud_server">Cloud Server</option>
                                        <option value="addon_cloud_server">Addon Cloud Server</option>
                                    </>
                                ) : (
                                    <></>
                                )
                            }
                            {
                                this.props.hosting ? (
                                    <>
                                        <option value="hosting_cpanel">Hosting Cpanel</option>
                                    </>
                                ) : (
                                    <></>
                                )
                            }
                        </select>
                    </div>
                    <div className="form-group">
                        <label htmlFor="group_user_id">Nhóm khách hàng</label>
                        <select className="form-control" name="group_user_id" id="group_user_id" onChange={this.changeInput} defaultValue={0}>
                            <option value="0">Cơ bản</option>
                            {
                                this.state.listGroupUser.map( (groupUser, keyUser ) => (
                                    <option value={ groupUser.id } key={keyUser}>{ groupUser.name }</option>
                                ))
                            }
                        </select>
                    </div>
                    <div className="form-group">
                        <label htmlFor="stt">Số thứ tự</label>
                        <input type="number" id="stt" name="stt" className="form-control" placeholder="Số thứ tự" defaultValue={10} onChange={this.changeInput} />
                    </div>
                    <div className="form-group row">
                        <div className="col-md-4">
                            <label>Ẩn nhóm</label>
                        </div>
                        <div className="col-md-8">
                            <input id="checkbox2" type="checkbox" name="hidden" onChange={this.changeInput} className="form-check-input" />
                        </div>
                    </div>
                </>
            )
        }
        else if ( action === 'editGroup' ) {
            this.setState({
                name: this.state.listGroupProduct[key].name,
                titleGroup: this.state.listGroupProduct[key].title,
                type_product: this.state.listGroupProduct[key].type,
                group_user_id: this.state.listGroupProduct[key].group_user_id,
                stt: this.state.listGroupProduct[key].stt,
                hidden: this.state.listGroupProduct[key].hidden,
                groupProductId: this.state.listGroupProduct[key].id,
            })
            return (
                <>
                    <div className="form-group">
                        <label htmlFor="name">Tên nhóm sản phẩm</label>
                        <input type="text" name="name" className="form-control" id="name"
                               placeholder="Tên nhóm sản phẩm" onChange={this.changeInput}
                               defaultValue={ this.state.listGroupProduct[key].name }
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="title">Tiêu đề hiển thị</label>
                        <input type="text" name="titleGroup" className="form-control" id="title"
                               placeholder="Tiêu đề hiển thị" onChange={this.changeInput}
                               defaultValue={ this.state.listGroupProduct[key].title }
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="type_product">Loại</label>
                        <select className="form-control" name="type_product" id="type_product" onChange={this.changeInput}
                                defaultValue={ this.state.listGroupProduct[key].type }
                        >
                            <option value="" disabled>Chọn loại sản phẩm</option>
                            {
                                this.props.vps ? (
                                    <>
                                        <option value="vps">VPS</option>
                                        <option value="addon_vps">Addon VPS</option>
                                    </>
                                ) : (
                                    <></>
                                )
                            }
                            {
                                this.props.vps_gpu ? (
                                    <>
                                        <option value="vps_gpu">VPS GPU</option>
                                    </>
                                ) : (
                                    <></>
                                )
                            }
                            {
                                this.props.nat_vps ? (
                                    <>
                                        <option value="nat_vps">NAT VPS</option>
                                        {
                                            !this.props.vps ? (
                                                <option value="addon_vps">Addon VPS</option>
                                            ) : (
                                                <></>
                                            )
                                        }
                                    </>
                                ) : (
                                    <></>
                                )
                            }
                            {
                                this.props.vps_us ? (
                                    <>
                                        <option value="vps_us">VPS US</option>
                                        <option value="vps_uk">VPS UK</option>
                                        <option value="vps_canada">VPS Canada</option>
                                        <option value="vps_singapore">VPS Singapore</option>
                                        <option value="vps_japan">VPS Japan</option>
                                    </>
                                ) : (
                                    <></>
                                )
                            }
                            {
                                this.props.proxy ? (
                                    <>
                                        <option value="proxy">Proxy</option>
                                    </>
                                ) : (
                                    <></>
                                )
                            }
                            {
                                this.props.cloudServer ? (
                                    <>
                                        <option value="cloud_server">Cloud Server</option>
                                        <option value="addon_cloud_server">Addon Cloud Server</option>
                                    </>
                                ) : (
                                    <></>
                                )
                            }
                            {
                                this.props.hosting ? (
                                    <>
                                        <option value="hosting_cpanel">Hosting Cpanel</option>
                                    </>
                                ) : (
                                    <></>
                                )
                            }
                        </select>
                    </div>
                    <div className="form-group">
                        <label htmlFor="group_user_id">Nhóm khách hàng</label>
                        <select className="form-control" name="group_user_id" id="group_user_id" onChange={this.changeInput}
                                defaultValue={ this.state.listGroupProduct[key].group_user_id }
                        >
                            <option value="0">Cơ bản</option>
                            {
                                this.state.listGroupUser.map( (groupUser, keyUser ) => (
                                    <option value={ groupUser.id } key={keyUser}>{ groupUser.name }</option>
                                ))
                            }
                        </select>
                    </div>
                    <div className="form-group">
                        <label htmlFor="stt">Số thứ tự</label>
                        <input type="number" id="stt" name="stt" className="form-control" placeholder="Số thứ tự"
                               onChange={this.changeInput}  defaultValue={ this.state.listGroupProduct[key].stt }
                        />
                    </div>
                    <div className="form-group row">
                        <div className="col-md-4">
                            <label>Ẩn nhóm</label>
                        </div>
                        <div className="col-md-8">
                            <input id="checkbox2" type="checkbox" name="hidden" onChange={this.changeInput}
                                   className="form-check-input"  defaultValue={ this.state.listGroupProduct[key].hidden }
                            />
                        </div>
                    </div>
                </>
            )
        }
        else if ( action === 'deleteGroup' ) {
            this.setState({
                groupProductId: this.state.listGroupProduct[key].id,
            })
            return (
                <div className="text-center">
                    Bạn có muốn xóa nhóm sản phẩm <b className="text-danger">{this.state.listGroupProduct[key].name}</b> này không? <br />
                    <span className="text-danger">
                        <b>Lưu ý: </b>
                        Hành động này rất nguy hiểm, có thể xóa tất cả dữ liệu về nhóm sản phẩm này. Vui lòng kiểm tra lại.
                    </span>
                </div>
            )
        }
        else if ( action === 'hidden' ) {
            this.setState({
                groupProductId: this.state.listGroupProduct[key].id,
            })
            return (
                <div className="text-center">
                    Bạn có muốn ẩn nhóm sản phẩm <b className="text-danger">{this.state.listGroupProduct[key].name}</b> này không? <br />
                </div>
            )
        }
        else if ( action === 'active' ) {
            this.setState({
                groupProductId: this.state.listGroupProduct[key].id,
            })
            return (
                <div className="text-center">
                    Bạn có muốn hiện nhóm sản phẩm <b className="text-danger">{this.state.listGroupProduct[key].name}</b> này không? <br />
                </div>
            )
        }
        else if ( action === 'deleteProduct' ) {
            return (
                <div className="text-center">
                    Bạn có muốn xóa sản phẩm <b className="text-danger">{ key.name }</b> này không? <br />
                    <span className="text-danger">
                        <b>Lưu ý: </b>
                        Hành động này rất nguy hiểm, có thể xóa tất cả dữ liệu về sản phẩm này. Vui lòng kiểm tra lại.
                    </span>
                </div>
            )
        }
    }

    changeInput = (event) => {
        let name = event.target.name;
        let value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        this.setState({
            [name]: value
        });
    }

    confirmModal = () => {
        if ( this.validate() ) {
            this.setState({
                btnConfirmDisabled: true,
                isSpinner: true,
                isBtnConfirm: false,
                alert: {
                    error: false,
                    message: ''
                }
            })
            let dataAuth = {
                username: process.env.REACT_APP_CLIENT_ID,
                password: process.env.REACT_APP_CLIENT_PASSWD,
                token: process.env.REACT_APP_KEY,
            };
            let form = this.getForm();

            axios.put( process.env.REACT_APP_API_URL + '/api/admin/product/actionGroupProduct', form,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization' : this.props.token,
                        'dataAgency' : JSON.stringify(dataAuth)
                    }
                }
            )
                .then( (ref) => {
                    // console.log(ref.data);
                    this.setState({
                        isSpinner: false,
                    });
                    if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                        this.props.logOut();
                    } else {
                        if ( this.state.action === 'deleteGroup' ) {
                            if ( !ref.data.error ) {
                                this.state.listGroupProduct.splice( this.state.actionKey , 1);
                            }
                        }
                        else {
                            if ( !ref.data.error ) {
                                window.scrollTo(0, 0);
                                this.listGroupProduct();
                            }
                        }
                        this.setState({
                            contentModal: {
                                modalBody: this.modalBodyConfirm(ref.data.error,ref.data.message),
                                title: this.state.contentModal.title
                            },
                        })
                    }
                    // console.log(this.state.perPage);
                })
                .catch( (error) => {
                    console.log(error);
                    this.setState({
                        isSpinner: false,
                        contentModal: {
                            title: this.state.contentModal.title,
                            modalBody: this.modalBodyConfirm(1, 'Thực hiện hành động không thành công')
                        },
                    })
                })
        }
    }

    getForm = () => {
        if ( this.state.action === 'createGroup' ) {
            return {
                action:  this.state.action,
                name:  this.state.name,
                title:  this.state.titleGroup,
                type_product:  this.state.type_product,
                group_user_id:  this.state.group_user_id,
                stt:  this.state.stt,
            };
        }
        else if ( this.state.action === 'editGroup' ) {
            return {
                action:  this.state.action,
                name:  this.state.name,
                title:  this.state.titleGroup,
                type_product:  this.state.type_product,
                group_user_id:  this.state.group_user_id,
                stt:  this.state.stt,
                groupProductId:  this.state.groupProductId,
            };
        }
        else if ( this.state.action === 'deleteGroup' ) {
            return {
                action:  this.state.action,
                groupProductId:  this.state.groupProductId,
            };
        }
        else if ( this.state.action === 'deleteProduct' ) {
            return {
                action:  this.state.action,
                productId:  this.state.actionKey.id,
            };
        }
        else if ( this.state.action === 'active' ) {
            return {
                action:  this.state.action,
                groupProductId:  this.state.groupProductId,
            };
        }
        else if ( this.state.action === 'hidden' ) {
            return {
                action:  this.state.action,
                groupProductId:  this.state.groupProductId,
            };
        }
    }

    validate = () => {
        if ( this.state.action === 'createGroup' ) {
            if ( this.state.name.length < 2 || this.state.name.length > 200 ) {
                this.setState({
                    alert: {
                        error: true,
                        message: 'Số ký tự của Tên nhóm sản phẩm phải lớn hơn 5 ký tự hoặc nhỏ hơn 200 ký tự'
                    }
                })
                return false;
            }
            else if ( this.state.titleGroup.length < 2 || this.state.titleGroup.length > 200 ) {
                this.setState({
                    alert: {
                        error: true,
                        message: 'Số ký tự của Tiêu đề nhóm sản phẩm phải lớn hơn 5 ký tự hoặc nhỏ hơn 200 ký tự'
                    }
                })
                return false;
            }
            else if ( !this.state.type_product.length ) {
                this.setState({
                    alert: {
                        error: true,
                        message: 'Loại sản phẩm không được để trống'
                    }
                })
                return false;
            }
        }
        return true;
    }

    modalBodyConfirm = (error, message) => {
        if ( error ) {
            return (
                <div className="text-center text-danger">
                    { message }
                </div>
            )
        } else {
            return (
                <div className="text-center text-success">
                    { message }
                </div>
            )
        }
    }

    // isNumber =  (n) => {
    //     return /^-?[\d.]+(?:e-?\d+)?$/.test(n);
    // }

    checkNotification = () => {
        if ( this.state.isNotification ) {
            return (
                <Alert color="success">
                    { this.state.textNotification }
                </Alert>
            );
        }
    }

    render() {
        return (
            <>
                {
                    this.state.loadPage ? (
                        <div className="cr-page-spinner load-page">
                            <Spinner animation="border" variant="primary" />
                        </div>
                    ) : (
                        <>
                            <Breadcrumb title={"Quản lý sản phẩm"} page={"Sản phẩm"} icon={<FaProductHunt className="breadcrumb-icon"/>} />
                            <div className="row mb-2">
                                <div className="col-8 mb-1">
                                    <button type="button" className="btn btn-primary mr-1" onClick={ () => this.showModal( null, 'createGroup' ) }>
                                        Tạo nhóm sản phẩm
                                    </button>
                                    <Link className="btn btn-success" to="/admin/san-pham/tao-san-pham">
                                        Tạo sản phẩm
                                    </Link>
                                </div>
                            </div>
                            <Card>
                                <CardBody>
                                    <div className="dataTables_wrapper form-inline dt-bootstrap">
                                        <div className="list-group-email row">
                                            <div className="col-md-12">
                                                {
                                                    this.checkNotification()
                                                }
                                            </div>
                                            <div className="col col-md-12 col-sm-12" id="config-system">
                                                { this.screentGroupProduct() }
                                            </div>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                            <ModalComponent
                                isModal={ this.state.isModal }
                                content={this.state.contentModal}
                                isBtnConfirm={ this.state.isBtnConfirm }
                                isSpinner={ this.state.isSpinner }
                                btnConfirmDisabled={ this.state.btnConfirmDisabled }
                                hiddenModal={ () => this.hiddenModal() }
                                confirmModal={ () => this.confirmModal() }
                                alert={ this.state.alert }
                            />
                        </>
                    )
                }
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.login.token,
        isNotification: state.adminMain.isNotification,
        textNotification: state.adminMain.textNotification,
        vps: state.system.vps,
        vps_gpu: state.system.vps_gpu,
        nat_vps: state.system.nat_vps,
        cloudServer: state.system.cloudServer,
        hosting: state.system.hosting,
        vps_us: state.system.vps_us,
        proxy: state.system.proxy,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        logOut: () => {
            dispatch(({ type : 'logOut', page: 'AdminProduct' }))
        },
        notification: (item) => {
            dispatch(({ type : 'notification', item }))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ListProductPage);